<template>
  <div class="animated fadeIn">
    <div class="cardheading">
      <h4><i class="fa fa-bars"></i><span class="ml-1">Popup Promo</span></h4>
      <div class="">
        <h1 class="my-auto tableName"></h1>
      </div>
      <div class="">
        <router-link :to="{ name: 'createScheduleNotification' }">
          <button class="btn btn-success">Create New Schedule Noti</button>
        </router-link>
      </div>
    </div>

    <b-row>
      <b-col>
        <b-card>
          <v-client-table
            :data="scheduleNoti"
            :columns="columns"
            :options="options"
          >
            <template slot="image" slot-scope="props">
              <div class="center-div">
                <img
                  :src="`${BASE_URL}/${props.row.banner}`"
                  style="width: 160px;height: 90px;"
                />
              </div>
            </template>
            <template slot="is_active" slot-scope="props"> </template>

            <template slot="action" slot-scope="props">
              <div>
                <router-link
                  :to="{
                    name: 'editScheduleNotification',
                    params: { id: props.row.id },
                  }"
                >
                  <span
                    class="btn btn-warning btn-sm m-1"
                    data-toggle="tooltip"
                    title="Edit"
                    :href="props.row.id"
                  >
                    <i class="fa fa-edit"></i>
                  </span>
                </router-link>
              </div>
            </template>
          </v-client-table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
const VUE_APP_BASE_URL = process.env.VUE_APP_BASE_URL;
const BASE_URL = "https://quizgiri.s3.ap-south-1.amazonaws.com";
export default {
  name: "scheduleNotification",
  data() {
    return {
      scheduleNoti: [],
      columns: ["image", "title", "body", "time", "status", "action"],
      BASE_URL: BASE_URL,
      ADMIN_URL: ADMIN_URL,
      VUE_APP_BASE_URL: VUE_APP_BASE_URL,
      src_image: "images/schedule-notification/",

      options: {
        customField: "Centered Content",
        pagination: { nav: "fixed" },
        filterByColumn: true,
        dateColumns: ["age"],
        toMomentFormat: "YYYY-MM-DD",
        sortIcon: {
          base: "fa fa-sort",
          up: "fa fa-sort-up",
          down: "fa fa-sort-down",
          is: "fa fa-sort",
        },
      },
    };
  },
  created() {
    axios
      .get(`${ADMIN_URL}/schedule-notification`)
      .then((response) => {
        this.scheduleNoti = response.data.data;
        // this.scheduleNoti = response.data.data.map(function (item){return item.assign({}, item, item.is_active="true")})
        // console.log('resepnse pormo',this.scheduleNoti);
      })
      .catch((e) => {
        console.log("error occurs", e.response);
      });
  },
  computed: {
    elementHasPermission(permission_name) {
      return (permission_name) => {
        return !!this.$store.getters["auth/hasPermission"](permission_name);
      };
    },
  },
  methods: {},
};
</script>
